import { FOUNDATION } from 'config/features';
import { queryKeys as sharedQueryKeys } from '../../../queryKeys';

export const QUERY_KEYS = {
  ...sharedQueryKeys,
  FEATURES: 'App/features',
  ALL_FEATURES: 'App/all_features',
  MULTI_SITE: 'App/multi_site',
  ORGANIZATION: 'App/organization',
  CONFIGURATION: 'App/configuration',
};

export const userQueryKey = () => [QUERY_KEYS.USER, { foundation: FOUNDATION }];
